/* == silk-page-scenario-showcase 2026-04-26 B + Day cycle drag showcase == */
(function() {
  const SECTION_SELECTOR = '.silk-page-scenario-showcase';

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function initScenarioShowcase(section) {
    if (!section || section.dataset.spssInitialized === 'true') {
      return;
    }

    const items = Array.from(section.querySelectorAll('.spss__item'));
    const lineMains = Array.from(section.querySelectorAll('.spss__drag-line-main'));
    const balls = Array.from(section.querySelectorAll('.spss__drag-ball'));
    const container = section.querySelector('.silk-page-scenario-showcase__container');
    const panel = section.querySelector('.spss__panel');
    const scrollSpacer = section.querySelector('.spss__scroll-spacer');

    if (!items.length || !lineMains.length || !balls.length || !container || !panel || !scrollSpacer) {
      return;
    }

    const sceneCount = items.length;
    const desktopMediaQuery = window.matchMedia('(min-width: 768px)');
    const state = {
      currentIndex: 0,
      currentProgress: 0,
      dragging: false,
      pointerId: null,
      dragBall: null,
      scrollTicking: false,
      syncingScrollFromControl: false
    };

    function getActiveItem() {
      return items[state.currentIndex] || items[0];
    }

    function getActiveLineMain() {
      const activeItem = getActiveItem();

      return activeItem ? activeItem.querySelector('.spss__drag-line-main') : lineMains[0];
    }

    function getBallWidth() {
      const activeBall = getActiveItem().querySelector('.spss__drag-ball');

      return activeBall ? activeBall.offsetWidth : 0;
    }

    function getHeadingGap() {
      return 20;
    }

    function getMaxOffset() {
      const activeLineMain = getActiveLineMain();

      if (!activeLineMain) {
        return 0;
      }

      const trackWidth = activeLineMain.clientWidth;
      const ballWidth = getBallWidth();

      if (!desktopMediaQuery.matches) {
        return Math.max(trackWidth - ballWidth, 0);
      }

      const heading = getActiveItem().querySelector('.spss__drag-line-heading');
      const headingWidth = heading ? heading.offsetWidth : 0;

      return Math.max(trackWidth - ballWidth - getHeadingGap() - headingWidth, 0);
    }

    function refreshProgressOffset() {
      section.style.setProperty('--spss-control-offset', getMaxOffset() * state.currentProgress + 'px');
    }

    function updateAria(activeHeading) {
      balls.forEach(function(ball, ballIndex) {
        const isActive = ballIndex === state.currentIndex;

        ball.setAttribute('aria-valuenow', String(state.currentIndex + 1));
        ball.setAttribute('aria-valuetext', activeHeading);
        ball.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    }

    function getPanelScrollHeight() {
      let maxHeight = panel.offsetHeight;

      items.forEach(function(item) {
        maxHeight = Math.max(maxHeight, item.offsetHeight, item.scrollHeight);
      });

      return maxHeight;
    }

    function syncStickyMetrics() {
      const panelHeight = getPanelScrollHeight();

      section.style.setProperty('--spss-panel-height', Math.max(panelHeight, 1) + 'px');
    }

    function getViewportTopOffset() {
      const sectionStyles = window.getComputedStyle(section);
      const bodyStyles = window.getComputedStyle(document.body);
      const headerHeightValue = sectionStyles.getPropertyValue('--spss-sticky-top') || bodyStyles.getPropertyValue('--section-header-height');
      const parsedHeaderHeight = parseFloat(headerHeightValue);

      return Number.isFinite(parsedHeaderHeight) ? parsedHeaderHeight : 0;
    }

    function getScrollProgressStart() {
      return section.offsetTop - getViewportTopOffset();
    }

    function getScrollTravelDistance() {
      return scrollSpacer.offsetHeight;
    }

    function syncScrollToProgress() {
      if (sceneCount <= 1) {
        return;
      }

      const travel = getScrollTravelDistance();

      if (travel <= 0) {
        return;
      }

      const targetY = getScrollProgressStart() + state.currentProgress * travel;

      state.syncingScrollFromControl = true;
      window.scrollTo(0, Math.max(targetY, 0));
      window.requestAnimationFrame(function() {
        state.syncingScrollFromControl = false;
      });
    }

    function setActiveItem(index) {
      const safeIndex = clamp(index, 0, sceneCount - 1);
      const activeItem = items[safeIndex];
      const activeHeading = activeItem.dataset.sceneHeading || 'Scene';

      items.forEach(function(item, itemIndex) {
        const isActive = itemIndex === safeIndex;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      state.currentIndex = safeIndex;
      section.setAttribute('data-active-scene', String(safeIndex + 1));
      updateAria(activeHeading);
      syncStickyMetrics();
      refreshProgressOffset();
    }

    function setProgress(progressValue, options) {
      const opts = options || {};
      const progress = clamp(progressValue, 0, 1);
      const maxOffset = getMaxOffset();
      const offset = maxOffset * progress;
      const nextIndex = sceneCount > 1 ? Math.round(progress * (sceneCount - 1)) : 0;

      state.currentProgress = progress;
      section.style.setProperty('--spss-control-offset', offset + 'px');
      section.style.setProperty('--spss-progress', String(progress));

      if (nextIndex !== state.currentIndex) {
        setActiveItem(nextIndex);
      } else if (!opts.skipOffsetRefresh) {
        refreshProgressOffset();
      }
    }

    function snapToIndex(index, options) {
      const opts = options || {};
      const safeIndex = clamp(index, 0, sceneCount - 1);
      const progress = sceneCount > 1 ? safeIndex / (sceneCount - 1) : 0;

      setActiveItem(safeIndex);
      state.currentProgress = progress;
      section.style.setProperty('--spss-control-offset', getMaxOffset() * progress + 'px');
      section.style.setProperty('--spss-progress', String(progress));
      if (opts.syncScroll !== false) {
        syncScrollToProgress();
      }
    }

    function updateFromClientX(clientX) {
      const activeLineMain = getActiveLineMain();
      const rect = activeLineMain.getBoundingClientRect();
      const ballWidth = getBallWidth();
      const rawOffset = clientX - rect.left - ballWidth / 2;
      const maxOffset = getMaxOffset();
      const progress = maxOffset > 0 ? clamp(rawOffset / maxOffset, 0, 1) : 0;

      setProgress(progress, { skipOffsetRefresh: false });
    }

    function updateProgressFromScroll() {
      if (sceneCount <= 1 || state.dragging || state.syncingScrollFromControl || !section.isConnected) {
        return;
      }

      const travel = getScrollTravelDistance();

      if (travel <= 0) {
        return;
      }

      const start = getScrollProgressStart();
      const progress = clamp((window.scrollY - start) / travel, 0, 1);

      setProgress(progress, { skipOffsetRefresh: false });
    }

    function startDrag(event) {
      if (sceneCount <= 1) {
        return;
      }

      state.dragging = true;
      state.pointerId = event.pointerId;
      state.dragBall = event.currentTarget.classList.contains('spss__drag-ball')
        ? event.currentTarget
        : event.currentTarget.querySelector('.spss__drag-ball');
      section.classList.add('is-dragging');
      if (state.dragBall) {
        state.dragBall.classList.add('is-dragging');
      }

      if (state.dragBall && typeof state.dragBall.setPointerCapture === 'function') {
        try {
          state.dragBall.setPointerCapture(event.pointerId);
        } catch (error) {
          /* noop */
        }
      }

      updateFromClientX(event.clientX);
    }

    function stopDrag() {
      if (!state.dragging) {
        return;
      }

      state.dragging = false;
      section.classList.remove('is-dragging');
      if (state.dragBall) {
        state.dragBall.classList.remove('is-dragging');
      }

      if (state.dragBall && typeof state.dragBall.releasePointerCapture === 'function' && state.pointerId !== null) {
        try {
          state.dragBall.releasePointerCapture(state.pointerId);
        } catch (error) {
          /* noop */
        }
      }

      state.pointerId = null;
      state.dragBall = null;
      syncScrollToProgress();
    }

    function handlePointerMove(event) {
      if (!state.dragging) {
        return;
      }

      updateFromClientX(event.clientX);
    }

    function handleKeydown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
        return;
      }

      event.preventDefault();

      if (event.key === 'ArrowLeft') {
        snapToIndex(state.currentIndex - 1);
        return;
      }

      snapToIndex(state.currentIndex + 1);
    }

    function handleResize() {
      syncStickyMetrics();
      refreshProgressOffset();
      updateProgressFromScroll();
    }

    function handleFontsReady() {
      syncStickyMetrics();
      refreshProgressOffset();
      updateProgressFromScroll();
    }

    function handleScroll() {
      if (sceneCount <= 1 || state.dragging || !section.isConnected) {
        return;
      }

      if (state.scrollTicking) {
        return;
      }

      state.scrollTicking = true;
      window.requestAnimationFrame(function() {
        state.scrollTicking = false;
        updateProgressFromScroll();
      });
    }

    function handlePointerDown(event) {
      event.preventDefault();
      startDrag(event);
    }

    syncStickyMetrics();
    section.style.setProperty('--spss-progress', '0');

    lineMains.forEach(function(lineMain) {
      lineMain.addEventListener('pointerdown', handlePointerDown);
    });

    balls.forEach(function(ball) {
      ball.addEventListener('keydown', handleKeydown);
    });
    window.addEventListener('pointermove', handlePointerMove);
    window.addEventListener('pointerup', stopDrag);
    window.addEventListener('pointercancel', stopDrag);
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll, { passive: true });

    if (document.fonts && typeof document.fonts.ready === 'object' && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(handleFontsReady).catch(function() {
        /* noop */
      });
    }

    section.__spssCleanup = function() {
      lineMains.forEach(function(lineMain) {
        lineMain.removeEventListener('pointerdown', handlePointerDown);
      });
      balls.forEach(function(ball) {
        ball.removeEventListener('keydown', handleKeydown);
      });
      window.removeEventListener('pointermove', handlePointerMove);
      window.removeEventListener('pointerup', stopDrag);
      window.removeEventListener('pointercancel', stopDrag);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll, { passive: true });
      section.classList.remove('is-dragging');
      stopDrag();
      delete section.__spssCleanup;
      delete section.dataset.spssInitialized;
    };

    section.dataset.spssInitialized = 'true';
    snapToIndex(0, { syncScroll: false });
    window.requestAnimationFrame(function() {
      syncStickyMetrics();
      updateProgressFromScroll();
    });
  }

  function destroyScenarioShowcase(section) {
    if (section && typeof section.__spssCleanup === 'function') {
      section.__spssCleanup();
    }
  }

  function initAllScenarioShowcases(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const sections = scope.matches && scope.matches(SECTION_SELECTOR)
      ? [scope]
      : Array.from(scope.querySelectorAll(SECTION_SELECTOR));

    sections.forEach(initScenarioShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAllScenarioShowcases(document);
    });
  } else {
    initAllScenarioShowcases(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAllScenarioShowcases(event.target);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    const scope = event.target;
    const sections = scope && scope.matches && scope.matches(SECTION_SELECTOR)
      ? [scope]
      : Array.from((scope && scope.querySelectorAll ? scope : document).querySelectorAll(SECTION_SELECTOR));

    sections.forEach(destroyScenarioShowcase);
  });
})();
/* == silk-page-scenario-showcase 2026-04-26 E + Day cycle drag showcase == */
